import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';


const InitializedModel = ({ allMeters, data, reloadList }, ref) => {

    const linkingUrl                =   BACKOFFICE_BASE_URL + '/asset_matrix_scs_linking_add';
    const access_token              =   useSelector(state => state.auth.access_token);

    const modalElem                 =   useRef(null);
    const modal                     =   useRef(null);

    const initialData               =   {
        scs_ids                         :   data.scs_ids,
        asset_matrix_id                 :   data.asset_matrix_id,
        status                          :   1,
        days_interval                   :   0,
        days_check                      :   'unchange'
    }

    const initializeMeterFields = () => {
        let meterFields = {};
        allMeters.forEach(meter => {
            meterFields[meter.key] = 'unchange';
            meterFields[`interval_${meter.key}`] = '';
        });
        return meterFields;
    };

    const [submitForm, setSubmitForm]   =   useState(false);
    const [formData, setFormData]       =   useState({
        ...initialData,
        ...initializeMeterFields()
    });

    useImperativeHandle(ref, () => ({
        initModalHandler: (data) => {
            if(data) {
                const mergedData = {
                    ...formData,
                    ...data,
                };
                if (data.meterValues) {
                    allMeters.forEach(meter => {
                        if (data.meterValues[meter.key]) {
                            mergedData[meter.key] = data.meterValues[meter.key].check;
                            mergedData[`interval_${meter.key}`] = data.meterValues[meter.key].interval;
                        }
                    });
                }
                setFormData(mergedData);
                modalOpen();
            }else {
                setFormData({
                    ...initialData,
                    ...initializeMeterFields()
                });
                modalOpen();
            }
        }
    }));

    useEffect(() => {
        modalElem.current   =   document.getElementById("InitializedModel");
        modal.current       =   new Modal(modalElem.current, { keyboard: false, backdrop: false });
    }, [data]);
  
    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose        =   ()  =>  {
        setFormData({
            ...initialData,
            ...initializeMeterFields()
        });
        if (modal.current) { modal.current.hide(); }
    };

    const submitFormData    =   (e)  =>  {
        e.preventDefault();

        const submitData = {
            scs_ids: formData.scs_ids,
            asset_matrix_id: formData.asset_matrix_id,
            status: formData.status,
            days_check: formData.days_check,
            days_interval: formData.days_check === 'Y' ? parseInt(formData.days_interval) || 0 : 0
        };

        allMeters.forEach(meter => {
            const meterKey = meter.key;
            submitData[meterKey] = formData[meterKey];
            submitData[`interval_${meterKey}`] = formData[meterKey] === 'Y' ? parseInt(formData[`interval_${meterKey}`]) || 0 : 0;
        });

        setSubmitForm(true);
        
        HttpAPICall.withAthorization('put', linkingUrl, access_token, {}, submitData, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            reloadList();
            modalClose();
        })
        .then(() => setSubmitForm(false));
    }

    const handleInputData   =   (e, key = null)  =>  {  
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleRadioChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const initializedModelJsx = () => {
        return (
            <div className="modal fade" id="InitializedModel" tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Change Interval</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => modalClose()}></button>
                        </div>
                        <form id="modelSearchForm" onSubmit={submitFormData}>
                            <div className="modal-body">
                                <div className="row my-3 align-items-center">
                                    <div className="col-sm-3">
                                        <label htmlFor="site_id" className="form-label">Tracking status</label>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-check form-check-inline">
                                            <input
                                                name="status"
                                                type="radio"
                                                value={1}
                                                onChange={(e) => handleInputData(e)}
                                                checked={formData.status == 1}
                                                className="form-check-input"
                                                required={true}
                                                id="trackingStatusFormEnable"
                                            />
                                            <label className="form-check-label" htmlFor="trackingStatusFormEnable">Enable</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-check form-check-inline">
                                            <input
                                                name="status"
                                                type="radio"
                                                value={2}
                                                onChange={(e) => handleInputData(e)}
                                                className="form-check-input"
                                                required={true}
                                                checked={formData.status == 2}
                                                id="trackingStatusFormDisable"
                                            />
                                            <label className="form-check-label" htmlFor="trackingStatusFormDisable">Disable</label>
                                        </div>
                                    </div>
                                </div>
                                
                                {formData.status == 1 && (
                                    <>
                                        {allMeters.map((meter, index) => {
                                            const checkField = meter.key;
                                            const intervalField = `interval_${meter.key}`;
                                            
                                            return (
                                                <div key={index} className="row my-3 align-items-center">
                                                    <div className="col-sm-3">
                                                        <label className="col-form-label">{meter.name}</label>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                value="Y"
                                                                onChange={() => handleRadioChange(checkField, 'Y')}
                                                                checked={formData[checkField] === 'Y'}
                                                                className="form-check-input"
                                                                id={`${meter.key}Enable`}
                                                            />
                                                            <label className="form-check-label" htmlFor={`${meter.key}Enable`}>Enable</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                value="N"
                                                                onChange={() => handleRadioChange(checkField, 'N')}
                                                                checked={formData[checkField] === 'N'}
                                                                className="form-check-input"
                                                                id={`${meter.key}Disable`}
                                                            />
                                                            <label className="form-check-label" htmlFor={`${meter.key}Disable`}>Disable</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                value="unchange"
                                                                onChange={() => handleRadioChange(checkField, 'unchange')}
                                                                checked={formData[checkField] === 'unchange'}
                                                                className="form-check-input"
                                                                id={`${meter.key}Unchange`}
                                                            />
                                                            <label className="form-check-label" htmlFor={`${meter.key}Unchange`}>Unchanged</label>
                                                        </div>
                                                    </div>
                                                    
                                                    {formData[checkField] === 'Y' && (
                                                        <div className="col-sm-3">
                                                            <input
                                                                name={intervalField}
                                                                type="text"
                                                                className="form-control"
                                                                placeholder={`Enter ${meter.name}`}
                                                                onChange={(e) => handleInputData(e)}
                                                                style={{ height: "30px", fontSize: "93%" }}
                                                                autoComplete="off"
                                                                value={formData[intervalField] || ''}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                        
                                        <div className="row my-3 align-items-center">
                                            <div className="col-sm-3">
                                                <label className="col-form-label">Days</label>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="radio"
                                                        value="Y"
                                                        onChange={() => handleRadioChange('days_check', 'Y')}
                                                        checked={formData.days_check === 'Y'}
                                                        className="form-check-input"
                                                        id="daysEnable"
                                                    />
                                                    <label className="form-check-label" htmlFor="daysEnable">Enable</label>
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="radio"
                                                        value="N"
                                                        onChange={() => handleRadioChange('days_check', 'N')}
                                                        checked={formData.days_check === 'N'}
                                                        className="form-check-input"
                                                        id="daysDisable"
                                                    />
                                                    <label className="form-check-label" htmlFor="daysDisable">Disable</label>
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="form-check form-check-inline">
                                                    <input
                                                        type="radio"
                                                        value="unchange"
                                                        onChange={() => handleRadioChange('days_check', 'unchange')}
                                                        checked={formData.days_check === 'unchange'}
                                                        className="form-check-input"
                                                        id="daysUnchange"
                                                    />
                                                    <label className="form-check-label" htmlFor="daysUnchange">Unchanged</label>
                                                </div>
                                            </div>
                                            
                                            {formData.days_check === 'Y' && (
                                                <div className="col-sm-3">
                                                    <input
                                                        name="days_interval"
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Days Interval"
                                                        onChange={(e) => handleInputData(e)}
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                        autoComplete="off"
                                                        value={formData.days_interval || ''}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" disabled={submitForm} className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => modalClose()}>Close</button>
                                <button type="submit" disabled={submitForm} className="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {initializedModelJsx()}
        </>
    );
};

export default forwardRef(InitializedModel);